import { render, staticRenderFns } from "./CodeLogin.vue?vue&type=template&id=04f52070&scoped=true&"
import script from "./CodeLogin.vue?vue&type=script&lang=js&"
export * from "./CodeLogin.vue?vue&type=script&lang=js&"
import style0 from "./CodeLogin.vue?vue&type=style&index=0&id=04f52070&lang=scss&scoped=true&"
import style1 from "./CodeLogin.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f52070",
  null
  
)

export default component.exports